/* eslint-disable no-useless-escape */
import React, { useEffect, useState } from "react";
import Background from "./Background";
import Select from "react-select";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "./popup.css";
import Utils from "../../lib/Utils";
import firebase from "../../lib/firebase";
import Loader from "../../Components/Loader";

const REASONS = [
  { value: "no_longer_using", label: "No longer using the platform" },
  { value: "privacy_concerns", label: "Privacy concerns" },
  { value: "found_better_alternative", label: "Found a better alternative" },
  {
    value: "too_much_time_spent",
    label: "Too much time spent on the platform",
  },
  { value: "security_concerns", label: "Security concerns" },
  { value: "received_spam_messages", label: "Received too many spam messages" },
  { value: "profile_data_breach", label: "Profile or data breach" },
  { value: "personal_reasons", label: "Personal reasons" },
  { value: "data_handling_concerns", label: "Concerns about data handling" },
  { value: "account_hacked", label: "Account was hacked" },
  { value: "inappropriate_content", label: "Received inappropriate content" },
  { value: "unsatisfactory_support", label: "Unsatisfactory customer support" },
  { value: "privacy_policy_changes", label: "Privacy policy changes" },
  { value: "account_duplication", label: "Account duplication" },
  { value: "closing_unused_accounts", label: "Closing unused accounts" },
  { value: "other", label: "Other" },
];

const DeleteAccountPopup = ({ isOpen, onClose }) => (
  <Popup open={isOpen} closeOnDocumentClick onClose={onClose}>
    <div className="popupModal">
      <button className="close" onClick={onClose}>
        &times;
      </button>
      <span className={"black-text2 f-monospace"} style={{ fontSize: 14 }}>
        Your account deletion request has been received. Please note that every
        request is processed manually, which may take up to 14 days. During this
        time, your account and data will be scheduled for permanent deletion,
        with no data saved on our servers. If you sign in during these 14 days,
        your request will be considered inactive, and your account will remain
        active. Thank you for being a part of our community.
      </span>
    </div>
  </Popup>
);

function DeleteAccount() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [number, setNumber] = useState(null);

  useEffect(() => {
    let $ = window.$;
    $("#c_preloader").fadeOut();
  }, []);

  function getClientInfo() {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;
    const cookiesEnabled = navigator.cookieEnabled || false;
    const mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(userAgent);

    let browser = "Unknown";
    let browserVersion = "Unknown";
    let os = "Unknown";
    let osVersion = "Unknown";

    const find = (regex) => regex.exec(userAgent);

    const browsers = {
      Chrome: () => find(/Chrome\/([\d.]+)/),
      Firefox: () => find(/Firefox\/([\d.]+)/),
      IE: () => find(/MSIE ([\d.]+)/),
      Edge: () => find(/Edg\/([\d.]+)/),
      Opera: () => find(/Opera\/([\d.]+)/),
      Safari: () => find(/Version\/([\d.]+).*Safari/),
      Yandex: () => find(/YaBrowser\/([\d.]+)/),
      Samsung: () => find(/SamsungBrowser\/([\d.]+)/),
      UC: () => find(/UCBrowser\/([\d.]+)/),
    };

    for (const browserName in browsers) {
      const match = browsers[browserName]();
      if (match) {
        [browser, browserVersion] = match;
        break;
      }
    }

    const osRegex = {
      Windows: /Windows\s(\d+\.\d+)/,
      macOS: /Mac OS X\s(\d+[\._]\d+)/,
      Android: /Android\s(\d+[\._]\d+)/,
      iOS: /OS\s(\d+[_\.]\d+[_\.]?\d*)/,
      Linux: /Linux/,
    };

    for (const osName in osRegex) {
      if (osRegex[osName].test(platform)) {
        [os, osVersion] = [osName, find(osRegex[osName])[1]];
        break;
      }
    }

    return {
      browser,
      browserVersion,
      os,
      osVersion,
      mobile,
      cookies: cookiesEnabled,
    };
  }

  const changeEmail = ({ target }) => {
    return setEmail(target?.value);
  };

  const changeNumber = ({ target }) => {
    return setNumber(target?.value);
  };

  const reasonHandler = ({ value }) => {
    return setReason(value);
  };

  const changePassword = ({ target }) => {
    return setPassword(target?.value);
  };

  const otherReasonChangeHandler = ({ target }) => {
    return setOtherReason(target?.value);
  };

  const closeModal = () => {
    return setSuccessModal(false);
  };

  const _handleDelete = async () => {
    setError(null);
    if ((email && !Utils.validateEmail(email)) || !number) {
      return setError(
        "Invalid email, please enter a valid email address or number"
      );
    }
    if (!reason) {
      return setError("Please selet the reason");
    }
    if (!password) {
      return setError("Please enter a password");
    }
    setLoading(true);
    try {
      const doc = firebase.firestore().collection("deleteRequests").doc();
      const { platform } = window.navigator.userAgentData;
      const client = getClientInfo();
      const data = {
        id: doc.id,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        email,
        password,
        number,
        reason,
        otherReason,
        platform,
        client,
      };
      await doc.set(data);
      setSuccessModal(true);
    } catch (error) {
      return;
    }
    setLoading(false);
  };

  return (
    <div>
      <Background />
      <div className="container-fluid d-flex align-items-center justify-content-center">
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-content d-flex flex-column align-items-center">
                <i className="sl-icon-trash font-24 red-text"></i>
                {/* <i className="material-icons large red-text align-self-center">
                  delete_forever
                </i> */}
                <h3>Delete Account</h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "400px",
                    margin: "20px",
                  }}
                >
                  <label
                    htmlFor="inputField"
                    style={{
                      fontSize: "18px",
                      marginBottom: "5px",
                      color: "#333",
                    }}
                  >
                    Enter Email:
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter email address"
                    style={{
                      border: "2px solid #ccc",
                      borderRadius: "5px",
                      padding: "10px",
                      fontSize: "16px",
                      outline: "none",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#007bff";
                      e.target.style.boxShadow =
                        "0 0 5px rgba(0, 123, 255, 0.5)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#ccc";
                      e.target.style.boxShadow = "none";
                    }}
                    onChange={changeEmail}
                  />
                  <label
                    htmlFor="inputField"
                    style={{
                      fontSize: "18px",
                      marginBottom: "5px",
                      color: "#333",
                    }}
                  >
                    or Enter Mobile:
                  </label>
                  <input
                    type="text"
                    id="phoneNumber"
                    placeholder="Enter mobile number in international format"
                    style={{
                      border: "2px solid #ccc",
                      borderRadius: "5px",
                      padding: "10px",
                      fontSize: "16px",
                      outline: "none",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#007bff";
                      e.target.style.boxShadow =
                        "0 0 5px rgba(0, 123, 255, 0.5)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#ccc";
                      e.target.style.boxShadow = "none";
                    }}
                    onChange={changeNumber}
                  />
                  <label
                    htmlFor="inputField"
                    style={{
                      fontSize: "18px",
                      marginBottom: "5px",
                      color: "#333",
                    }}
                  >
                    Enter Password:
                  </label>
                  <input
                    type="password"
                    id="password"
                    placeholder="Enter password"
                    style={{
                      border: "2px solid #ccc",
                      borderRadius: "5px",
                      padding: "10px",
                      fontSize: "16px",
                      outline: "none",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#007bff";
                      e.target.style.boxShadow =
                        "0 0 5px rgba(0, 123, 255, 0.5)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#ccc";
                      e.target.style.boxShadow = "none";
                    }}
                    onChange={changePassword}
                  />
                  <Select
                    options={REASONS}
                    isSearchable={false}
                    isMulti={false}
                    id={"reasons"}
                    onChange={reasonHandler}
                  />
                  {reason?.toLocaleLowerCase() === "other" && (
                    <>
                      <label
                        htmlFor="inputField"
                        style={{
                          fontSize: "18px",
                          marginBottom: "5px",
                          color: "#333",
                        }}
                      >
                        Enter Reason:
                      </label>
                      <input
                        type="text"
                        id="password"
                        placeholder="Please specify"
                        style={{
                          border: "2px solid #ccc",
                          borderRadius: "5px",
                          padding: "10px",
                          fontSize: "16px",
                          outline: "none",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#007bff";
                          e.target.style.boxShadow =
                            "0 0 5px rgba(0, 123, 255, 0.5)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#ccc";
                          e.target.style.boxShadow = "none";
                        }}
                        onChange={otherReasonChangeHandler}
                      />
                    </>
                  )}
                </div>
                {error && (
                  <span className={"materialize-red-text text-lighten-1"}>
                    {error}
                  </span>
                )}
                <div className="row m-t-20">
                  <button
                    className="btn-large w100 black d-flex align-items-center justify-content-center"
                    onClick={_handleDelete}
                  >
                    {loading ? <Loader size={"small"} /> : "Delete Account"}
                  </button>
                </div>
                <DeleteAccountPopup
                  isOpen={successModal}
                  onClose={closeModal}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteAccount;
